import _ from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';

import SectionLoader from '@/src/components/common/Elements/Spinner/SectionLoader/SectionLoader';
import { RootState } from '@/src/reducers/types';

import Body from './Body/Body';
import Container from './Container/Container';
import Header from './Header/Header';
import SelectAllCheckbox from './Header/SelectAll/SelectAllCheckbox';

import { useGetTrash } from '../../api/getTrash';
import { FileListProvider } from '../../store/file-list.store';
import { useLibrarySearchParamsContext } from '../../store/filters.store';

type ListProps = {
  projectId: string;
  draggingData: any;
};

export const TrashList = ({ projectId, draggingData }: ListProps) => {
  const files = useSelector((state: RootState) => state.files);
  const folderId = files.activeFolder?.id;
  const selectedItems = files.selectedItems;
  const { filter } = useLibrarySearchParamsContext();
  const filesQuery = useGetTrash({
    projectId: +projectId,
    filter,
  });
  const flatFiles = filesQuery.data?.pages.flatMap((page) => page.data) || [];

  const isLoading = filesQuery.isLoading;
  const showFolders = !folderId && flatFiles.length > 0;
  const showNoRecords = !isLoading && !folderId && !flatFiles.length;
  const filesWithSelection =
    flatFiles?.map((item) => ({
      ...item,
      isSelected: selectedItems.map((f) => f.id)?.includes(item.id),
    })) ?? [];

  // if (isLoading) {
  //   return (
  //     <Container>
  //       <Header />
  //       <SectionLoader />
  //     </Container>
  //   );
  // }

  return (
    <FileListProvider filesQuery={filesQuery}>
      <Container>
        <Header SelectAllComponent={<SelectAllCheckbox flatFiles={flatFiles} />} />

        {showFolders && <Body list={filesWithSelection} draggingData={draggingData} />}

        {showNoRecords && <p className="noRecordsFound">No records found.</p>}

        {filesQuery.hasNextPage && (
          <div className="loadMoreFiles">
            <a onClick={() => filesQuery.fetchNextPage()}>Load More</a>
          </div>
        )}
      </Container>
    </FileListProvider>
  );
};
